import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(reset-password)/page.module.scss");
import(/* webpackMode: "eager" */ "/app/src/app/assets/images/reset-password/logo.svg")